export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_KEYHANDLING_KEYDEVICE",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_KEYHANDLING_KEYDEVICE",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_KEYHANDLING_KEYDEVICE",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_KEYHANDLING_KEYDEVICE",
  DESTROY_FORM: "DESTROY_FORM_KEYHANDLING_KEYDEVICE",
  SET_FORM_ERROR: "SET_FORM_ERROR_KEYHANDLING_KEYDEVICE",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_KEYHANDLING_KEYDEVICE",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_KEYHANDLING_KEYDEVICE",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_KEYHANDLING_KEYDEVICE",
  RESET_STATE: "RESET_STATE_KEYHANDLING_KEYDEVICE",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_KEYHANDLING_KEYDEVICE",
  REMOVE_OBJECT: "REMOVE_OBJECT_KEYHANDLING_KEYDEVICE",
  CLEAR_FETCHED: "CLEAR_FETCHED_KEYHANDLING_KEYDEVICE",

  LIST_URL: "/keyhandling/keydevice/list/",
  POST_URL: "/keyhandling/keydevice/",
  PATCH_URL: "/keyhandling/keydevice/",
  GET_URL: "/keyhandling/keydevice/",

  STORE_NAME: "keydevice",
};
